export default {
    mock: {
        API: "",
    },
    test: {
        API: "https://netease-cloud-music-api-eight-ochre-11.vercel.app",
    },
    development: {
        API: "https://netease-cloud-music-api-eight-ochre-11.vercel.app",
    },
    production: {
        API: "https://netease-cloud-music-api-eight-ochre-11.vercel.app",
    },
};
